import ActivityLog from '@components/activityLog/ActivityLog'
import { useAppSelector } from '@store/hooks'
import { selectSelectedUser } from '@store/UserReducer'
import { Col, Row, Spin } from 'antd'

const ActivitiesTab = () => {
  const user = useAppSelector(selectSelectedUser())

  if (!user) {
    return <Spin />
  }

  return (
    <Row gutter={[32, 32]}>
      <Col span={24}>
        <ActivityLog.Timeline entity="user" entityId={user.id} />
      </Col>
    </Row>
  )
}

export default ActivitiesTab
